export const contextDefaults = {
  firstActor: {
    name: "",
    image: "",
    id: 0,
    most_popular_recent_movie: {},
    gender: "",
    type: "",
    date: "",
  },
  lastActor: {
    name: "",
    image: "",
    id: 0,
    most_popular_recent_movie: {},
    gender: "",
    type: "",
    date: "",
  },
  guesses: [{}],
  changeGuesses: () => [],
  currentMoves: 0,
  changeCurrentMoves: () => {},
  win: false,
  changeWin: () => {},
  alreadyRewarded: false,
  changeAlreadyRewarded: () => {},
  darkMode: true,
  changeDarkMode: () => [],
  currentEmojiGrid: [],
  changeEmojiGrid: () => [],
  currentlyPlayingDate: "",
  changeCurrentlyPlayingDate: () => {},
  currentArchivedActorsResults: [],
  changeCurrentArchivedActorsResults: () => {},
  fullTimezoneDate: "",
  changeFullTimezoneDate: () => {},
  objectiveCurrentDate: "",
  changeObjectiveCurrentDate: () => {},
  currentSelection: {
    id: 0,
    name: "",
    year: "",
    image: "",
  },
  changeCurrentSelection: () => {},
  movieCast: [],
  changeMovieCast: () => {},
  currentDegrees: 0,
  changeCurrentDegrees: () => {},
  guessLoading: false,
  changeGuessLoading: () => {},
  updateWinData: false,
  changeUpdateWinData: () => {},
  pathRankCount: {},
  changePathRankCount: () => {},
  showTopPathsModal: false,
  changeShowTopPathsModal: () => {},
  currentHoliday: "",
  changeCurrentHoliday: () => {},
  changeFirstActor: () => {},
  changeLastActor: () => {},
};
